var $61d07b1b4be4496b$exports = {};
$61d07b1b4be4496b$exports = {
    "collapse": `Sa\u{17E}mi`,
    "expand": `Pro\u{161}iri`
};


export {$61d07b1b4be4496b$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
